import { JsonObject, JsonProperty } from 'json2typescript';

import { AbstractEntity } from '../abstract-entity/abstract-entity';
import { TenantAddress } from '../address/tenant-address';
import { TenantAttr } from '../attr/tenant-attr';
import { TenantLogo } from './logo';
import { TenantConfig } from './tenant-config';
import { TenantPicture } from './tenant-picture';
import { TenantSyncConfig } from './tenant-sync-config';
import { TenantUsableModuleType } from './tenant-usable-module-type.enum';
import { ThemeColor } from './theme-color';
import { VersionType } from './version-type.enum';

/**
 * å»é¢
 */
@JsonObject
export class Tenant extends AbstractEntity {
  /**
   * ç®¡çåè´¦å·Id
   */
  @JsonProperty('accountId', Number)
  accountId: number = undefined;

  /**
   * å»é¢å°å
   */
  @JsonProperty('address', TenantAddress)
  address: TenantAddress = undefined;

  /**
   * å»é¢å«å
   */
  @JsonProperty('alias', Number)
  alias: string = undefined;

  /**
   * è¯¥å»é¢æéç½®çåç±»éç½®
   * æ³¨ï¼ï¼ä¹åç»ä¸ä½¿ç¨tenantConfigï¼ç±äºçµæ¯è¿å¤ï¼ææ¶ä¿çï¼
   */
  @JsonProperty('attrs', [TenantAttr])
  attrs: TenantAttr[] = undefined;

  /**
   * å»é¢èç³»çµè¯
   * ä¾: 021-2222221
   */
  @JsonProperty('contact', String)
  contact: string = undefined;

  /**
   * å»é¢æè¿°
   */
  @JsonProperty('desc', String)
  desc: string = undefined;

  /**
   * å»é¢è¿ææ¶é´(æå»é¢è®¸å¯ä½¿ç¨çå°ææ¶é´, æ¶é´æ³)
   */
  @JsonProperty('expiredTime', Number)
  expiredTime: number = undefined;

  /**
   * å»é¢ç­çº§(ä¾:ä¸çº§ç²ç­)
   */
  @JsonProperty('level', String)
  level: string = undefined;

  /**
   * å»é¢logoå¾ç
   */
  @JsonProperty('logo', TenantLogo)
  logo: TenantLogo = undefined;

  /**
   * å»é¢åç§°
   */
  @JsonProperty('name', String)
  name: string = undefined;

  /**
   * å»é¢èªå®ä¹å¾ç(ç¨äºé¦é¡µè½®æ­å¾ç­)
   */
  @JsonProperty('pictures', [TenantPicture])
  pictures: TenantPicture[] = undefined;

  /**
   * å»é¢éç½®
   */
  @JsonProperty('config', TenantConfig)
  config: TenantConfig = undefined;

  /**
   * åæ­¥éç½®
   */
  @JsonProperty('syncConfig', TenantConfig)
  syncConfig: TenantSyncConfig = undefined;

  /**
   * ç¦ç¨å¯ç¨ç¶æ
   */
  @JsonProperty('enabled', Boolean)
  enabled: boolean = undefined;

  /**
   * åç«¯å¶å®çæ¨¡åï¼å¯ç¨æ¨¡åï¼
   */
  @JsonProperty('modules', [TenantUsableModuleType])
  modules: TenantUsableModuleType[] = undefined;

  /**
   * çæ¬æ§å¶
   */
  @JsonProperty('versionType', VersionType)
  versionType: VersionType = undefined;

  /**
   * æ¯å¦æ¾ç¤ºå¾®ä¿¡æ¬æµ®å¹¿åçª
   */
  @JsonProperty('showAdvertisingWindow', Boolean)
  showAdvertisingWindow: boolean = undefined;

  /**
   * éç½®çä¸»é¢è²
   */
  @JsonProperty('themeColor', ThemeColor)
  themeColor: ThemeColor = undefined;

  constructor() {
    super();
    this.logo = new TenantLogo();
  }
}
